import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import type { AbstractPaymentService } from '@pe/checkout/payment';
import { NodePaymentResponseInterface, PaymentMethodEnum } from '@pe/checkout/types';

import { FlowState } from '../flow';


@Injectable({
  providedIn: 'root',
})
export class PaymentProxyService {
  private readonly store = inject(Store);

  private readonly paymentsService = new Map<PaymentMethodEnum, AbstractPaymentService>();

  private get paymentMethod(): PaymentMethodEnum {
    return this.store.selectSnapshot(FlowState.paymentMethod);
  }

  public setPaymentService(paymentService: AbstractPaymentService): void {
    const splitPaymentType = paymentService.splitPaymentType;
    this.paymentsService.set(splitPaymentType ?? this.paymentMethod, paymentService);
  }

  public postPayment(): Observable<NodePaymentResponseInterface<any> | boolean> {
    const service = this.paymentsService.get(this.paymentMethod);
    if (!service) {
      throw new Error(`Payment service for method ${this.paymentMethod} is not registered.`);
    }

    return service.postPayment?.();
  }

  public redirect(): void {
    const service = this.paymentsService.get(this.paymentMethod);
    if (!service) {
      throw new Error(`Payment service for method ${this.paymentMethod} is not registered.`);
    }
    service.redirect?.();
  }
}
